import React from "react";
import { useFeatures } from "../../hooks/useFeatures";
import { Github, Smartphone, Link as LinkIcon } from "lucide-react";
import GitHubConnection from "./GitHubConnection";
import ExpoIntegration from "./ExpoIntegration";
import FeatureUpgradePrompt from "../common/FeatureUpgradePrompt";

const IntegrationsSection: React.FC = () => {
  const { has } = useFeatures();
  const hasGithubIntegration = !!(has && has("github-integration"));
  const hasExpoIntegration = !!(has && has("expo-integration"));
  return (
    <div className="p-6">
      <div className="mb-6">
        <h2 className="text-2xl font-semibold text-neutral-900 dark:text-white">
          Integrations
        </h2>
        <p className="text-sm text-neutral-600 dark:text-neutral-400 mt-1">
          Connect external services to enable deeper workflows.
        </p>
      </div>

      {!hasGithubIntegration && !hasExpoIntegration ? (
        <FeatureUpgradePrompt
          icon={LinkIcon}
          title="Upgrade to Enable Integrations"
          description="Connect your workspace with GitHub repositories and Expo projects to streamline your development workflow."
        />
      ) : (
        <div className="space-y-4">
          {hasGithubIntegration && (
            <div className="bg-slate-100 dark:bg-neutral-800 rounded-lg border border-slate-300 dark:border-neutral-700 p-6">
              <div className="flex items-center gap-2 mb-4">
                <Github className="w-5 h-5 text-neutral-900 dark:text-white" />
                <h3 className="text-lg font-semibold text-neutral-900 dark:text-white">
                  GitHub
                </h3>
              </div>
              <GitHubConnection />
            </div>
          )}
          
          {hasExpoIntegration && (
            <div className="bg-slate-100 dark:bg-neutral-800 rounded-lg border border-slate-300 dark:border-neutral-700 p-6">
              <div className="flex items-center gap-2 mb-4">
                <Smartphone className="w-5 h-5 text-neutral-900 dark:text-white" />
                <h3 className="text-lg font-semibold text-neutral-900 dark:text-white">
                  Expo
                </h3>
              </div>
              <ExpoIntegration />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default IntegrationsSection;
